
export const formStyles = theme => ({
    fieldDiv: {
        backgroundColor: theme.palette.slateGray,
        position: 'absolute',
        borderRadius: '4px',
        padding: '0px 12px',
        paddingBottom: '12px',
        flexDirection: 'column'
    },
    multiline: {
        padding: '0'
    },
    fieldLabel: {
        color: theme.palette.cloudyBlue,
        fontSize: '11px',
    },
    hiddenText: {
        color: theme.palette.cloudyBlue,
        fontSize: '18px',
        whiteSpace: 'pre-line',
        visibility: 'hidden',
        height: '2px'
    },
    textFieldInput: {
        color: theme.palette.white,
        backgroundColor: theme.palette.fieldGray,
        borderRadius: '4px',
        padding: '4px 8px',
        height: '24px'
    },
    fieldIconContainer: {
        display: 'flex',
        marginTop: '2vh'
    },
    formIcons: {
        marginRight: '1vw',
        cursor: 'pointer'
    }
})
